import {ScrollHome} from './styles';

export function ScrollDown(){
    return(
    <ScrollHome>
        <a href="#about">
            <span>
                <i className="uil uil-mouse-alt"></i>
                Role para baixo
            </span>
            <i className="uil uil-arrow-down"></i>
        </a>
    </ScrollHome>
    )
}